// 将原来存cookies中的数据存vuex

const account = {
  state: {
    shopTokenuserparam: null,
    shopTokenapps: null,
    shopTokenuser: null,
    urlSearch: null
  },
  mutations: {
    SET_USERPARAM: (state, shopTokenuserparam) => {
      state.shopTokenuserparam = shopTokenuserparam
    },
    SET_APPS: (state, shopTokenapps) => {
      state.shopTokenapps = shopTokenapps
    },
    SET_USER: (state, shopTokenuser) => {
      state.shopTokenuser = shopTokenuser
    },
    SET_HREF: (state, urlSearch) => {
      state.urlSearch = urlSearch
    }
  },
  actions: {
    setUserparam: ({commit}, shopTokenuserparam) => {
      commit('SET_USERPARAM', shopTokenuserparam)
    },
    setApps: ({commit}, shopTokenapps) => {
      commit('SET_APPS', shopTokenapps)
    },
    setUser: ({commit}, shopTokenuser) => {
      commit('SET_USER', shopTokenuser)
    },
    setHref: ({commit}, urlSearch) => {
      commit('SET_HREF', urlSearch)
    }
  }
}
export default account



// WEBPACK FOOTER //
// ./src/store/modules/cookies.js